// Canonical accent-insensitive search normalization. Zero-import leaf so any
// search surface (including the probe-importable bsb-search-core.ts) can adopt
// it. The single normalizer for prayer search, Bible verse search
// (bsb-search-core.ts), and topic search (topic-search.ts) as of the
// Bible-search normalizer-unify chunk.
// `\p{M}` covers every Unicode combining-mark block, not only the original
// U+0300..U+036F range. Default-ignorable code points (zero-width joiners,
// variation selectors, soft hyphens, bidi controls, and their peers) are
// removed so an invisible character cannot split an otherwise visible word.
// These are static expressions; user input is never compiled as a RegExp.
const COMBINING_MARK_RE = /\p{M}+/gu;
const DEFAULT_IGNORABLE_RE = /\p{Default_Ignorable_Code_Point}+/gu;

export function normalizeForSearch(text: string): string {
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(COMBINING_MARK_RE, '')
    .replace(DEFAULT_IGNORABLE_RE, '')
    .replace(/\s+/g, ' ')
    .trim();
}
